'use strict'

const config = {
  en: require('./locales/en'),
  pt: require('./locales/pt'),
  ja: require('./locales/ja')
}

/**
 * Returns the configuration corresponding to the specified locale.
 * @param {string} locale (e.g. 'pt-BR')
 */
function getLocaleConfig(locale) {
  const [language, region] = locale.toLowerCase().split('-')
  const availableLocales = Object.keys(config)

  if (region && availableLocales.indexOf(`${language}-${region}`) !== -1) {
    // Return a region-specific config (e.g. en-GB)
    return config[`${language}-${region}`]
  } else if (availableLocales.indexOf(language) !== -1) {
    // Return a language-specific config (e.g. en)
    return config[language]
  } else {
    return undefined
  }
}

function getRuleMatching(value, locale) {
  const valueInt = parseInt(value, 10)

  let languageConfig = getLocaleConfig(locale) || []

  for (const item of languageConfig) {
    if (!item.if || item.if(valueInt)) {
      return item
    }
  }

  return undefined
}

function getOrdinalSuffix(value, locale, options = {}) {
  const rule = getRuleMatching(value, locale)
  if (rule) {
    const { suffix } = rule
    if (typeof suffix === 'function') {
      return suffix(options)
    } else {
      return suffix
    }
  } else {
    console.warn(`[ordinal] Couldn't find a rule that matches value=${value} and locale=${locale}`)
    return ''
  }
}

function getOrdinal(value, locale, options = {}) {
  const prefix = '' // Not supported yet
  const valueInt = parseInt(value, 10)
  const suffix = getOrdinalSuffix(value, locale, options)

  return `${prefix}${valueInt}${suffix}`
}

module.exports = {
  getLocaleConfig,
  getOrdinal,
  getOrdinalSuffix
}
